import React, { useState } from 'react';
import './DeleteConfirmationModal.css';

function LeaveHouseholdModal({ isOpen, onClose, onConfirm, householdName }) {
  const [selectedAction, setSelectedAction] = useState(null);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (selectedAction) {
      onConfirm(selectedAction);
    }
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal-header" style={{ background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', borderBottomColor: '#fcd34d' }}>
          <h2 style={{ color: '#92400e' }}>🚪 Leave Household</h2>
        </div>

        <div className="delete-modal-body">
          <p className="delete-item-name">
            You are about to leave <strong style={{ color: '#92400e' }}>"{householdName}"</strong>
          </p>
          
          <p className="delete-question">
            Choose what happens after you leave:
          </p>

          <div className="delete-options">
            <label 
              className={`delete-option ${selectedAction === 'archive' ? 'selected' : ''}`}
              onClick={() => setSelectedAction('archive')}
            >
              <input 
                type="radio" 
                name="leaveAction" 
                value="archive"
                checked={selectedAction === 'archive'}
                onChange={() => setSelectedAction('archive')}
              />
              <div className="option-content">
                <div className="option-header">
                  <span className="option-icon">📦</span>
                  <span className="option-title">Archive for me</span>
                  <span className="option-badge recommended">Recommended</span>
                </div>
                <p className="option-description">
                  Move to your "Deleted Households" tab. You can rejoin later or restore it.
                  Your expense history will be preserved.
                </p>
              </div>
            </label>

            <label 
              className={`delete-option ${selectedAction === 'leave' ? 'selected danger' : ''}`}
              onClick={() => setSelectedAction('leave')}
            >
              <input 
                type="radio" 
                name="leaveAction" 
                value="leave"
                checked={selectedAction === 'leave'}
                onChange={() => setSelectedAction('leave')}
              />
              <div className="option-content">
                <div className="option-header">
                  <span className="option-icon">🚪</span>
                  <span className="option-title">Leave completely</span>
                </div>
                <p className="option-description">
                  Remove yourself from this household entirely. 
                  You'll need a new invite code to rejoin.
                </p>
              </div>
            </label>
          </div>

          <div className="related-items-warning" style={{ marginTop: '20px' }}>
            <span className="warning-icon">ℹ️</span>
            <span>This will not delete the household for other members. They will continue to have access.</span>
          </div>
        </div>

        <div className="delete-modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button 
            className={`confirm-btn ${selectedAction === 'leave' ? 'danger' : 'warning'}`}
            onClick={handleConfirm}
            disabled={!selectedAction}
            style={!selectedAction ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            {selectedAction === 'archive' ? '📦 Archive & Leave' : 
             selectedAction === 'leave' ? '🚪 Leave Household' : 
             'Select an option'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LeaveHouseholdModal;
